<template>
  <div v-if="!mobile" class="main-form-search main-anim">
    <div class="row">
      <div class="col text-center">
        <div class="title bold">{{ claim }}</div>
      </div>
    </div>
    <form
      ref="form"
      autocomplete="off"
      method="POST"
      action="/search?home=true"
    >
      <input
        ref="geojson"
        autocomplete="false"
        type="hidden"
        value=""
        name="geojson"
        id="geojson_desktop"
      />

      <input type="hidden" name="_token" :value="csrf" />

      <div class="row main-container align-items-center">
        <div class="col">
          <div class="row align-items-center">
            <div class="col">
              <vue-select
                labelcolor="#FFFFFF"
                :primarycolor="colors.primary"
                style="flex: 1 1 auto;"
                :options="formdata.categorie"
                title="Cosa stai cercando?"
                name="categoria"
                trackby="id"
                :required="true"
                :allowEmpty="false"
                @onChange="$emit('get-tipologie', $event)"
                :currentvalue="selectedValue.categoria"
                selectname="categoria"
                placeholder="Seleziona..."
              ></vue-select>
            </div>

            <div class="col">
              <vue-select
                labelcolor="#FFFFFF"
                :primarycolor="colors.primary"
                style="flex: 1 1 auto;"
                :options="formdata.contratti"
                title="Contratti"
                name="contratto"
                trackby="id"
                :required="true"
                :allowEmpty="false"
                @onChange="$emit('update-prezzi', $event)"
                :currentvalue="selectedValue.contratto"
                selectname="contratto"
                placeholder="Seleziona..."
              ></vue-select>
            </div>

            <div class="col" style="height: 77px">

            <div class="input-group" id="tipologie">
              <vue-select
                labelcolor="#FFFFFF"
                :primarycolor="colors.primary"
                style="flex: 1 1 auto;"
                :options="formdata.tipologie"
                name="tipologie"
                title="Tipologia"
                trackby="id"
                :closeonselect="false"
                :currentvalue="selectedValue.tipologie"
                :multiple="true"
                selectname="tipologie"
                placeholder="Seleziona..."
                selection_name="tipologie"
                @onChange="$emit('cambio-tipologie', $event)"
                :required="true"
              ></vue-select>
            </div>
          </div>

          <div class="w-100"></div>

          <div class="col">
            <div id="zone" class="input-group">
              <zone-select
                label="Comune o Zona"
                labelcolor="#FFFFFF"
                :primarycolor="colors.primary"
                name="zone"
                style="flex: 1 1 auto;"
                selectname="zone"
                trackby="id"
                :disabled="!$root.mapselected ? false : true"
                :required="!$root.mapselected ? true : false"
                :currentvalue="selectedValue.zone"
                :options="homepagedata.zone"
                placeholder="Seleziona..."
                @onChange="$emit('zone-added', $event)"
              ></zone-select>

              <div class="input-group-append">
                <button
                  v-if="$root.mapselected"
                  class="mapSearchBtn remove-btn mapSearchBtn-advanced btn-brr btn-secondary-sm selected"
                  @click="$emit('removeselection')"
                  type="button"
                >
                  Rimuovi Selezione Mappa
                </button>

                <button
                  v-if="!$root.mapselected"
                  class="mapSearchBtn mapSearchBtn-advanced btn-brr btn-secondary-sm"
                  @click="$emit('showmap')"
                  type="button"
                >
                  Disegna area di ricerca
                </button>
              </div>
            </div>
          </div>

          <div class="col">
            <vue-select-price
              labelcolor="#FFFFFF"
              :primarycolor="colors.primary"
              :prezzi="formdata.prezzi"
              :currentsearch="null"
            ></vue-select-price>
          </div>
        </div>
      </div>

      <div class="col-2 btn-search-ctn">
        <div class="col">
          <button
            class="submit-btn call-to-action-primary"
            type="submit"
          >
            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
            <template v-else>Cerca Subito</template>
          </button>
        </div>
      </div>
    </div>
  </form>
</div></template>

<script>
export default {
  name: 'HomeCampiForm',
  props: ['colors', 'homepagedata', 'formdata', 'selectedValue', 'remove-selection', 'cattegorie', 'claim', 'mobile'],
  data () {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      loading: false,
    }
  },
  
  mounted () {
    this.$refs.form.addEventListener('submit', () => {
      this.loading = this.$refs.form.checkValidity();
    })
  },
}
</script>

<style lang="scss">.vuemulti {
  label {
    font-weight: bold !important;
  }
}</style>